import PageHeader from 'components/common/PageHeader';
import AdvanceTablePagination from 'components/common/usersTable/AdvanceTablePagination';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';
import { getPropertiesByFilters } from 'redux/propsSlice';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import { checkPermission } from 'utils/checkPermission';
import { informacion, propsColumns } from '../propertyWizard/steps/data/props';
import PropsCards from './propertiesTable/PropsCards';
import PropsTable from './propertiesTable/PropsTable';
import Spinner from 'react-bootstrap/Spinner';
import ListFilterComponent from './propertiesTable/components/ListFilterComponent';
import ListOrderComponent from './propertiesTable/components/ListOrderComponent';
import { PropActions } from './propertiesTable/components/PropActions';
import AlertaSistemas from 'helpers/alertaSistemas';
import WidgetStats from '../../gestionarInmobiliaria/components/WidgetStats';
import { getRealEstateByUserId } from 'redux/realEstateSlice';
import SelectBar from './propertiesTable/components/SelectBar/SelectBar';
moment.locale('es');

export const propStatusObj = {
  pending: 'Pendiente',
  published: 'Activa',
  paused: 'Pausada',
  deleted: 'Eliminada',
  finished: 'Finalizada'
};

const ListaPropiedades = () => {
  //Parametro traido desde la URL para obtener el filtro viniendo desde el componente resumen -- Conrado
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const filtro = queryParams.get('filtro');

  //Hooks e informacion base del usuario
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userLogged = useSelector(state => state.login.currentUser);
  const branchOffices = useSelector(state => state.branchOffice.branchOffices);
  const rolesUser = useSelector(state => state.roles.rolesById);
  const permisos = [];

  // State con array de elementos seleccionados
  const [selected, setSelected] = useState([]);

  if (userLogged?.typeOfUser !== 'admin') {
    userLogged?.roles?.map(roles =>
      rolesUser[roles.id]?.roleToPermission?.map(
        permiso =>
          permisos.indexOf(permiso.permission.id) === -1 &&
          permisos.push(permiso.permission.id)
      )
    );
  }
  //State para render
  const [checkChanges, setCheckChanges] = useState(false);

  //Estado base
  const [data, setData] = useState();

  //Estado para oficina actual y lista de props
  const {
    branchOfficeProps: properties,
    neighborhoodsObj,
    loading
  } = useSelector(state => state.props);

  //Estados para paginacion
  const [page, setPage] = useState({ number: 1 });
  const [propsLimit, setPropsLimit] = useState(10);
  const [totalProps, setTotalProps] = useState(0);
  const [filtersAndSort, setFiltersAndSort] = useState({
    branchOffices: [],
    status: filtro !== null ? [filtro] : [], // implementacion del filtro viniendo del Componente "Resumen" en caso de que exista
    propertyTypes: [],
    operation: 0,
    shared: 'all',
    sortBy: {
      prop: 'updated_at',
      order: 'desc'
    },
    neighborhoods: [],
    price: {
      min: '',
      max: '',
      currency: 'ARS'
    },
    surface: {
      min: '',
      max: '',
      type: 'totalSurface'
    },
    ambiences: [],
    bedrooms: [],
    bathrooms: [],
    garages: [],
    extras: []
  });

  //Estado para búsqueda
  const [searchProp, setSearchProp] = useState('');
  const [searchAddress, setSearchAddress] = useState('');

  //filtrado y sort de propiedades mostradas
  const [filtredProps, setFiltredProps] = useState(properties?.list);

  const [type, setType] = useState('cards');

  const canNextPage = Math.ceil(totalProps / propsLimit) > page.number;
  const canPreviousPage = page.number > 1;

  const nextPage = () => {
    setPage(prev => ({ number: prev.number + 1 }));
  };

  const previousPage = () => {
    setPage(prev => ({ number: prev.number - 1 }));
  };

  const submitSearch = value => {
    setSearchProp(value);
  };
  const submitSearchAddress = value => setSearchAddress(value);

  const HandleCheckbox = () => {
    if (selected.length > 0) setSelected([]);
    else {
      setSelected(
        data.map(prop => ({
          id: prop.id,
          title: prop.title,
          status: prop.status,
          branch_office: prop.branch_office_id
        }))
      );
    }
  };

  //Get Branch Offices
  useEffect(() => {
    if (userLogged) {
      dispatch(getBranchOfficesByUserId(userLogged.id));
      dispatch(getRealEstateByUserId(userLogged.id));
    }
  }, [userLogged]);
  useEffect(() => {
    setPage({ number: 1 });
    setCheckChanges(true);
  }, [branchOffices, filtersAndSort, propsLimit, searchProp, searchAddress]);

  useEffect(() => {
    if (page && filtersAndSort && propsLimit && checkChanges && !loading) {
      let newFilterAndSort = { ...filtersAndSort };

      dispatch(
        getPropertiesByFilters(
          newFilterAndSort,
          page.number,
          propsLimit,
          searchProp,
          searchAddress
        )
      );
      //
    }
  }, [checkChanges]);

  //inicializo las dos listas de propiedades en base a la lista actual
  useEffect(() => {
    if (properties) {
      setFiltredProps(properties.list);
      setTotalProps(properties?.length);
    }
  }, [properties]);

  useEffect(() => {
    if (filtredProps) {
      const array = filtredProps?.map(prop => {
        const mappedObj = {
          id: prop._id,
          title: prop.title,
          images: prop.images,
          branch_office_id: prop.branch_office_id,
          address: `${prop.location.street} ${prop.location.number || ''}`,
          barrios: neighborhoodsObj[prop.location.barrios?.at(-1)],
          price: `${
            prop.price?.total ? informacion.currency[prop.price.currency] : ''
          } ${
            prop.price?.total?.toLocaleString('en-US') || 'Sin precio asignado'
          }`,
          operation: `${informacion.operation[prop.operation_type]}`,
          updated_at: dayjs(prop.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          created_at: dayjs(prop.created_at).format('DD/MM/YYYY HH:mm [hs]'),
          type: informacion.property[prop.property_type],
          status: propStatusObj[prop.status],
          statistics: prop.statistics,
          actions: (
            <PropActions
              prop={prop}
              userLogged={userLogged}
              setCheckChanges={setCheckChanges}
            />
          ),
          share: prop.share,
          owner: prop.owner,
          publication: prop.publication,
          rawProp: prop
        };

        if (prop.price?.expenses) {
          mappedObj.expenses = `${
            prop.price?.expenses
              ? informacion.currency[prop.price.expensesCurrency]
              : ''
          } ${
            prop.price?.expenses?.toLocaleString('en-US') ||
            'Sin precio asignado'
          }`;
        }

        return mappedObj;
      });
      setCheckChanges(false);
      setData(array);
    }
  }, [filtredProps]);

  return (
    <>
      {userLogged && branchOffices && (
        <>
          <AlertaSistemas />
          <Row style={{ display: 'flex', alignItems: 'stretch' }}>
            <Col xs={12} md={7} style={{ display: 'flex' }}>
              <PageHeader
                title="Mis Propiedades"
                description="Mantenga al día el estado de sus propiedades, así como sus fotografías, y no descuide los mensajes de los interesados."
                className="mb-3 bg-white"
              >
                {userLogged &&
                  checkPermission('Create properties', userLogged) && (
                    <ButtonCreate
                      className="w-100 w-lg-auto"
                      text="Nueva Propiedad"
                      funcion={() => navigate('/propiedades/cargar')}
                      variant="primary"
                    />
                  )}
              </PageHeader>
            </Col>
            <Col xs={12} md={5} style={{ display: 'flex' }}>
              <WidgetStats title="Propiedades" />
            </Col>
          </Row>

          <Row className="g-3">
            <Col xs={12} lg={3} xxl={2}>
              <ListFilterComponent
                filtersAndSort={filtersAndSort}
                setFiltersAndSort={setFiltersAndSort}
                branchOffices={branchOffices}
                submitSearch={submitSearch}
                searchAddress={submitSearchAddress}
                searchingAddress={!!searchAddress}
                searching={!!searchProp}
                neighborhoods={properties.neighborhoods}
              />
            </Col>

            <Col xs={12} lg={9} xxl={10}>
              <Row className="g-1">
                <Col xs={12}>
                  <ListOrderComponent
                    type={type}
                    setType={setType}
                    page={page.number}
                    propsLimit={propsLimit}
                    setPropsLimit={setPropsLimit}
                    totalProps={totalProps}
                    filtersAndSort={filtersAndSort}
                    setFiltersAndSort={setFiltersAndSort}
                    rowsPerPageOptions={[10, 15, 20, 25]}
                    loading={loading}
                  />
                </Col>

                <Col xs={12}>
                  <SelectBar
                    selected={selected}
                    setSelected={setSelected}
                    handleCheckbox={HandleCheckbox}
                    setCheckChanges={setCheckChanges}
                  />
                </Col>

                <Col
                  xs={12}
                  style={{
                    minHeight: '400px'
                  }}
                >
                  {loading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                      }}
                    >
                      <Spinner
                        animation="border"
                        style={{
                          color: '#2c7be5'
                        }}
                      />
                    </div>
                  ) : (
                    data &&
                    propsColumns &&
                    (type === 'table' ? (
                      <PropsTable
                        data={data}
                        propsLimit={Number(propsLimit)}
                        columns={propsColumns}
                        filtersAndSort={filtersAndSort}
                        setFiltersAndSort={setFiltersAndSort}
                        loading={loading}
                        type="property"
                      />
                    ) : (
                      <PropsCards
                        properties={data}
                        length={properties.length}
                        loading={loading}
                        propsLimit={Number(propsLimit)}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    ))
                  )}
                </Col>

                <Col xs={12} className="pt-2">
                  <AdvanceTablePagination
                    canNextPage={canNextPage}
                    canPreviousPage={canPreviousPage}
                    pageCount={Math.ceil(totalProps / propsLimit)}
                    gotoPage={page => setPage({ number: page + 1 })}
                    nextPage={nextPage}
                    pageIndex={page.number - 1}
                    previousPage={previousPage}
                    setCheckChanges={setCheckChanges}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ListaPropiedades;
